import * as React from 'react';
import { Route, Routes } from 'react-router-dom-v5-compat';

import Error404 from 'af-root/scenes/Error/error404';

import AttachmentsTab from 'af-components/SharedForms/Job/AttachmentsTab';
import BillingCodes from 'af-components/SharedForms/Job/BillingCodes';
import Details from 'af-components/SharedForms/Job/Details';
import JobHazardAssessment from 'af-components/SharedForms/Job/JobHazardAssessment';

import JobCreate from './index';
import { JobCreateTabRoutes } from './types';

const JobCreateRouter: React.FC = () => {
	return (
		<Routes>
			<Route
				element={<JobCreate />}
			>
				<Route element={<Details />} index />
				<Route element={<Details />} path={`/${JobCreateTabRoutes.DETAILS}`} />
				<Route element={<BillingCodes />} path={`/${JobCreateTabRoutes.BILLING_CODES}`} />
				<Route element={<JobHazardAssessment />} path={`/${JobCreateTabRoutes.JOB_HAZARD_ASSESSMENT}`} />
				<Route element={<AttachmentsTab />} path={`/${JobCreateTabRoutes.ATTACHMENTS}`} />
			</Route>
			<Route element={<Error404 />} path="*" />
		</Routes>
	);
};

export default React.memo(JobCreateRouter);
